import { render, staticRenderFns } from "./AgentForm.vue?vue&type=template&id=a5357d38&scoped=true&"
import script from "./AgentForm.vue?vue&type=script&lang=js&"
export * from "./AgentForm.vue?vue&type=script&lang=js&"
import style0 from "./AgentForm.vue?vue&type=style&index=0&id=a5357d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5357d38",
  null
  
)

export default component.exports